import {Component} from '@angular/core';

import {RouterOutlet} from "@angular/router";

@Component({
    selector: 'app-public',
    imports: [
    RouterOutlet
],
    templateUrl: './public.component.html',
    styleUrls: ['./public.component.css']
})
export class PublicComponent {

}
